import React, { Component } from "react";
import Avatar from './darkpatterns2d/Avatar';

class RoundEndText extends Component {
	constructor(props) {
		super(props);
		this.state = { timerKey : undefined };
	}
	componentDidMount() {
		// console.log( this.props.duration );
		this.setState({ timerKey : setTimeout( this.props.callback, this.props.duration * 1000 ) });
	}
	componentWillUnmount() {
		clearTimeout(this.state.timerKey)
	}
	render() {
		let animationStyles = { animationDuration: `${this.props.duration - 1}s`};
		return (
			<div className="game-placard-wrapper">
				<div className="game-placard" style={animationStyles}>
					<div className="inner-game-placard end-placard">
						<div className="avatar3dintro">
							<Avatar round={this.props.round} look={3} speaking={false} className="avatarIcon"/>
							<div className="avatarSays">{this.props.text}</div>	
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default RoundEndText;



// WEBPACK FOOTER //
// ./src/components/RoundEndText.js